/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsTaggedImageViewProps } from '../../../modules/hosports-tagged-image/./hosports-tagged-image';
//@ts-ignore
import {GetProductsBySlugs,OrderProductsByPrice,GetRidersBySlugs} from './../utilities/dataFunctions';
//@ts-ignore
import {GetLocalizedText,GetLocalizedPrice} from './../utilities/functions';
//@ts-ignore
import {StaticAssetUrl,ProductAssetUrl,GeneralAssetUrl} from './../utilities/constants';
import PortalModal from './../../../baseComponents/portal-modal/./portal-modal';

interface IState {
  ready:boolean;
  onBackgroundImageLoaded:boolean;
  onFullScreenImageLoaded:boolean;
  fullScreen:boolean;
  riders:any,
  products:any
}

/**
 *
 * Hero component
 * @extends {React.Component<IHosportsTaggedImageViewProps<IHosportsTaggedImageViewPropsData>>}
 */
class HosportsTaggedImage extends React.Component<IHosportsTaggedImageViewProps,IState> {

  public state: IState;

  constructor(props: IHosportsTaggedImageViewProps) {
    super(props);
    this.state = {
      ready:false,
      onBackgroundImageLoaded:false,
      onFullScreenImageLoaded:false,
      fullScreen:false,
      riders:[],
      products:[]
    };
  }

  public componentDidMount = async() => {
    const { config } = this.props;
    let riderArray = [];
    let productArray = [];
    if(config.products){
      for (var i = 0; i < config.products.length; i++) {
        productArray.push(config.products[i])
      }
    }
    if(config.riders){
      for (var i = 0; i < config.riders.length; i++) {
        riderArray.push(config.riders[i])
      }
    }
    let products = await GetProductsBySlugs(productArray,config.year);
    let riders = await GetRidersBySlugs(riderArray);
    this.setState({
      products:products,
      riders:riders
    })
  }

  public onFullScreenImageLoad = () => {
    this.setState({
      onFullScreenImageLoaded:true
    })
  }

  public onBackgroundImageLoad = () => {
    this.setState({
      onBackgroundImageLoaded:true
    })
  }

  public activateFullScreen = () => {
    this.setState({
      onFullScreenImageLoaded:false,
      fullScreen:true
    })
  }

  public hideFullScreen = () => {
    this.setState({
      fullScreen:false
    })
  }

  public render(): JSX.Element {
    const { config } = this.props;
    let backgroundImage:any = config.backgroundImage ? 'url('+config.backgroundImage.src+')' : null ;
    let targetImage:any = config.image ? config.image.src : null;
    targetImage = config.backgroundImage ? config.backgroundImage.src : targetImage;
    let backgroundImageLoadedClass:string = "loaded";
    let fullScreenImageLoadedClass:string = "";
    if(config.backgroundImage){
      backgroundImageLoadedClass = ""
    }
    if(this.state.onBackgroundImageLoaded){
      backgroundImageLoadedClass = "loaded"
    }
    if(this.state.onFullScreenImageLoaded){
      fullScreenImageLoadedClass = "loaded"
    }
    console.log(this.state.products)
    console.log(this.state.riders)
    return (
      <div {...config} className={"tagged-image-overlay-container"} >
        {config.backgroundImage && <img className="tagged-image-background-preload" src={config.backgroundImage.src} onLoad={this.onBackgroundImageLoad} />}
        {config.image && <img className={"tagged-image-original-image "+backgroundImageLoadedClass} src={config.image.src} style={{backgroundImage:backgroundImage}}  onClick={this.activateFullScreen} />}
        <div className="tagged-image-tag-hover-icon" onClick={this.activateFullScreen} >
          <img src={StaticAssetUrl+'/images/tag-icon.png'} />
        </div>
        {this.state.fullScreen &&
          <PortalModal
            modalHidden={this.hideFullScreen}
            modalActive={this.state.fullScreen}
            content={
              <div className="tagged-image-full-screen-container row active full-height full-width">
                <img className={"tagged-image-background-preload"} src={targetImage} onLoad={this.onFullScreenImageLoad} />
                <h4 className="show-for-small tagged-image-overlay-container-title-sm white small-padding">{'In This Photo'}</h4>
                <div
                  className={"tagged-image-overlay-image "+fullScreenImageLoadedClass}
                  style={{backgroundImage:'url('+targetImage+')'}}>
                </div>
                <div
                  className="tagged-image-overlay-tag-container dark-grey-background">
                  <h4 className="hide-for-small tagged-image-overlay-container-title white">{'In This Photo'}</h4>
                  {this.state.riders && this.state.riders.map((data:any) =>{
                    let link:string = "/rider/"+data.attributes.slug;
                    let image:string ="";
                    if(data.attributes && data.attributes.cover){
                      image = data.attributes.cover.url();
                    }
                    let name:string = data.attributes.firstName+" "+data.attributes.lastName;
                    return(
                      <div className="border-bottom tagged-image-overlay-product">
                        <a href={link} className="row">
                          <div className="small-4 medium-4 tagged-image-overlay-product-image centered-text">
                            <img className="full-width circle background-image-fill" src={GeneralAssetUrl+'square.png'} style={{backgroundImage:'url(https://assets.hosports.com/image.php?src='+image+'&h=200&w=200&zc=1)'}} />
                          </div>
                          <div className="small-8 medium-8 tagged-image-overlay-product-text" style={{display:'flex', alignItems:'center'}}>
                              <div className="full-width">
                                <h6 className="white">{name}</h6>
                                <p className="white subheading">&nbsp;</p>
                              </div>
                          </div>
                        </a>
                      </div>
                    )
                  })}
                  {this.state.products && this.state.products.map(async(data:any) =>{
                    let link:string = "/product/"+data.attributes.slug;
                    let title:Promise<string> = await GetLocalizedText(data.attributes.content,'title');
                    let price:Promise<string> = await GetLocalizedPrice(data.attributes.content,'price');

                    return(
                      <div className="border-bottom tagged-image-overlay-product">
                        <a href={link} className="row">
                          <div className="small-4 medium-4 tagged-image-overlay-product-image">
                            <img className="full-width background-image-fill black-background circle" src={GeneralAssetUrl+'square.png'} style={{backgroundImage:'url('+ProductAssetUrl+data.attributes.slug+'1_500.png'+')'}} />
                          </div>
                          <div className="small-8 medium-8 tagged-image-overlay-product-text" style={{display:'flex', alignItems:'center'}}>
                              <div className="full-width">
                                <h6 className="white">{title}</h6>
                                <p className="white subheading">{price}</p>
                              </div>
                          </div>
                        </a>
                      </div>
                    )
                  })}
                </div>
            </div>
            }
          />
        }
      </div>
    );
  }
}

export const cssClassCoversionDictionary = {
  threeQuarter:'three-quarter',
  half:'half',
  quarter:'quarter',
  full:'full',
  centerCenter:'center-center',
  leftCenter:'left-center',
  rightCenter:'right-center',
  bottomLeft:'bottom-left',
  bottomRight:'bottom-right',
  bottomCenter:'bottom-center',
  topLeft:'top-left',
  topRight:'top-right',
  topCenter:'top-center'
};

export default HosportsTaggedImage;
